
const V2Components = {
  _components: {},

  register(name, component) {
    this._components[name] = component;
  },

  get(name) {
    return this._components[name];
  },

  list() {
    return Object.keys(this._components)
      .map(key => this._components[key]);
  },

  clear(name) {
    delete this._components[name];
  },

  clearAll() {
    this._components = {};
  },
};

export default V2Components;
